import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography, Alert } from '@mui/material';
import { ReactNode } from 'react';

export type ModalConfirmProps = {
  open: boolean;
  title: string;
  subtitle?: string;
  contentNode?: ReactNode;
  onClose: () => void | Promise<void>;
  onConfirm: () => void;
  confirmText?: string;
  cancelText?: string;
  footerText?: string
};

export default function ModalConfirm({
  open,
  title,
  subtitle,
  contentNode,
  onClose,
  onConfirm,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  footerText,
}: ModalConfirmProps) {
  return (
    <Dialog open={open} maxWidth="md" fullWidth onClose={onClose}>
      <DialogTitle sx={{ fontWeight: 'bold', fontSize: '1.5rem' }}>{title}</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {subtitle && (
            <>
              {/* <Typography variant="body2" color="text.secondary">
              {subtitle}
              </Typography> */}
              <Alert variant="outlined" severity="info" /* sx={{color:'white'}} */>
                <Typography variant="body2" color="text.secondary" sx={{fontWeight:'bold'}}>
                  {subtitle}
                </Typography>
              </Alert>

            </>

          )}
          {contentNode}
        </Box>
      </DialogContent>

      {footerText && (
        <Box sx={{ px: 3, pb: 1, textAlign: 'right' }}>
          <Typography variant="body2" sx={{ fontWeight: 'bold' }} color="text.secondary">
            {footerText}
          </Typography>
        </Box>
      )}
      <DialogActions sx={{ px: 3 }}>
        <Button onClick={async () => await onClose()} variant="outlined">{cancelText}</Button>
        <Button onClick={onConfirm} variant="contained">{confirmText}</Button>
      </DialogActions>
    </Dialog>
  );
}
